import React from 'react'

class PaymentTerm extends React.Component {

  renderPaymentTerm = () => {
    const payment_term = this.props.payment_term

    if(payment_term == "monthly_credit_card"){
      return "Monthly Subscription (Automatic card payments)"
    }
    else if(payment_term == "monthly_subscription_manual"){
      return "Monthly Subscription (Manual Payments)"
    }
    else if(payment_term == "eft_instalments"){
      return "EFT Instalments"
    }
    else if(payment_term == "full_payment_upfront"){
      return "Full Payment Upfront"
    }
    else {
      return payment_term
    }
  }

  render() {
    return (
      <span>{this.renderPaymentTerm()}</span>
    )
  }
}

export default PaymentTerm
